module.exports = __webpack_public_path__ + "static/media/reach_mass.83f84fc1.svg";